import { render, staticRenderFns } from "./orderFinal.vue?vue&type=template&id=7cffb028&scoped=true&"
import script from "./orderFinal.vue?vue&type=script&lang=js&"
export * from "./orderFinal.vue?vue&type=script&lang=js&"
import style0 from "./orderFinal.vue?vue&type=style&index=0&id=7cffb028&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cffb028",
  null
  
)

export default component.exports